import {ChangeDetectionStrategy, Component, computed, input, OnInit, output} from "@angular/core"
import {MatTooltipModule} from "@angular/material/tooltip"
import {ListItemComponent} from "@common/components/item"
import {Operator} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/operator"
import {byOperatorType, OperatorDesc} from "@app/textures/texture-editor/operators-panel/operator-desc"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-operator-list-item",
    templateUrl: "./operator-list-item.component.html",
    styleUrls: ["./operator-list-item.component.scss"],
    imports: [ListItemComponent, MatTooltipModule],
})
export class OperatorListItemComponent implements OnInit {
    readonly $disabled = input(false, {alias: "disabled"})
    readonly $isInactive = input(false, {alias: "isInactive"})
    readonly $operator = input.required<Operator>({alias: "operator"})

    readonly selectOperatorClick = output<Operator>()
    readonly lockOperatorClick = output<Operator>()
    readonly enableOperatorClick = output<Operator>()
    readonly deleteOperatorClick = output<Operator>()
    readonly duplicateOperatorClick = output<Operator>()

    ngOnInit(): void {
        this.desc = byOperatorType[this.$operator().type]
    }

    readonly $label = computed(() => this.desc.label)

    readonly $icon = computed(() => this.desc.icon)

    readonly $selected = computed(() => this.$operator().$selected())

    readonly $locked = computed(() => this.$disabled() || this.$operator().$locked())

    readonly $enabled = computed(() => this.$operator().$enabled())

    readonly $edited = computed(() => this.$operator().$edited())

    readonly $isInternalOperator = computed(() => this.$operator().flags.has("is-internal"))

    readonly $canDuplicate = computed(() => !this.$operator().flags.has("no-clone"))

    readonly $canDisable = computed(() => !this.$operator().flags.has("no-disable"))

    selectOperator() {
        this.selectOperatorClick.emit(this.$operator())
    }

    toggleLocked(): void {
        this.lockOperatorClick.emit(this.$operator())
    }

    toggleEnabled(): void {
        this.enableOperatorClick.emit(this.$operator())
    }

    deleteOperator(): void {
        this.deleteOperatorClick.emit(this.$operator())
    }

    duplicateOperator(): void {
        this.duplicateOperatorClick.emit(this.$operator())
    }

    private desc!: OperatorDesc
}
